import { initSection } from '../../core/shopify/init-section/index.js';
import Swiper, { Autoplay, Lazy } from 'swiper';
const NAMESPACE = '.js-full-screen-slider';
initSection(NAMESPACE, (section)=>{
    const swiperEl = section.querySelector('.js-full-screen-slider-swiper');
    if (!swiperEl) return {
        unload: null
    };
    var _swiperEl_dataset_delay;
    const delay = parseInt((_swiperEl_dataset_delay = swiperEl.dataset.delay) !== null && _swiperEl_dataset_delay !== void 0 ? _swiperEl_dataset_delay : '1000', 10);
    Swiper.use([
        Autoplay,
        Lazy
    ]);
    const swiper = new Swiper(swiperEl, {
        loop: true,
        speed: 0,
        preloadImages: false,
        watchSlidesProgress: true,
        allowTouchMove: false,
        simulateTouch: false,
        autoplay: {
            delay,
            disableOnInteraction: false
        },
        lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 1
        }
    });
    return {
        unload: ()=>{
            swiper.destroy(true, true);
        }
    };
});
